// extracted by mini-css-extract-plugin
module.exports = {"container":"quote_container___AYCL","quote":"quote_quote__a9Jtz","quotee":"quote_quotee__OsyM_","grid":"quote_grid__dXTGP"};